import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldOff } from "lucide-react";

export default function AdminForbidden() {
  const navigate = useNavigate();
  return (
    <div data-testid="admin-forbidden-page" className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mb-4">
        <ShieldOff className="w-8 h-8 text-red-500" />
      </div>
      <h1 className="text-2xl font-bold text-[#1C3A7A] mb-2">Access denied</h1>
      <p className="text-gray-600 max-w-md mb-6">
        You don't have permission for this area. If you believe you need access,
        contact the Super Admin.
      </p>
      <button
        data-testid="forbidden-back-btn"
        onClick={() => navigate("/admin")}
        className="px-5 py-2 rounded-lg bg-[#1C3A7A] text-white font-medium hover:bg-[#16305F]"
      >
        Back to Dashboard
      </button>
    </div>
  );
}
